
// Open/Close Event
document.querySelector('.spec-group-btn').onclick = function (e) {
    document.getElementById('collapseOne').classList.toggle('open');
}

// Check Heignt to disable attibutes collapse
if(document.querySelector('.spec-group-container .spec-detail').offsetHeight < 550){
    document.getElementById('collapseOne').classList.add('attributes-collapse-disabled');
}

// Open/Close Event
document.querySelector('.spec-advance-btn').onclick = function (e) {
    document.getElementById('collapseFour').classList.toggle('open');
}

// Check Heignt to disable attibutes collapse
/* if(document.get('.spec-group-container .spec-detail').offsetHeight < 550){
    document.getElementById('collapseOne').classList.add('attributes-collapse-disabled');
} */